import { useEconomicCalendarSectionContent } from './useEconomicCalendarSectionContent';
import { parseEconomicCalendarBehindTheDataContent } from '../utils/economicCalendarContent';

export const useEconomicCalendarBehindTheDataContent = () =>
  useEconomicCalendarSectionContent(parseEconomicCalendarBehindTheDataContent);
